import all from '@mailobj-browser/front/js/selectors/all.js'
import { events } from '#components/generics/js/childHideable/container.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import * as utilities from '#utilities/js/styles.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { elements } from '../styles.js'

const manageButtonsGroup = element => {
  const buttonsGroup = closest(`.${elements.buttons}`, element)

  if (buttonsGroup) {
    const { children } = buttonsGroup
    let allActionsAreHidden = true

    for (const action of children) {
      if (!action.classList.contains(utilities.modifiers.display.none)) {
        allActionsAreHidden = false

        break
      }
    }

    if (allActionsAreHidden) {
      buttonsGroup.classList.add(utilities.modifiers.display.none)
    } else {
      buttonsGroup.classList.remove(utilities.modifiers.display.none)
    }
  }
}

const manageMarginRightOnLastVisibleButton = container => {
  const buttonsGroups = all(`.${elements.buttons}:not(${utilities.modifiers.display.none})`, container)

  for (const buttonsGroup of buttonsGroups) {
    const actionVisible = all(`.${elements.button}:not(.${utilities.modifiers.display.none})`, buttonsGroup)

    if (actionVisible.length) {
      const lastActionVisible = actionVisible[actionVisible.length - 1]

      for (const action of actionVisible) {
        action.classList.remove(utilities.modifiers.margin_right.zero)
      }

      lastActionVisible.classList.add(utilities.modifiers.margin_right.zero)
    }
  }
}

const onChildHideableManageParent = object(listener, {
  type: events.manageParent,
  passive,
  task: (
    container,
    { detail: element }
  ) => {
    if (element) {
      manageButtonsGroup(element)
    }
  }
})

const onChildHideableReady = object(listener, {
  type: events.ready,
  passive,
  task: (
    container
  ) => {
    manageMarginRightOnLastVisibleButton(container)
  }
})

export default container => {
  onChildHideableManageParent.listen(container)
  onChildHideableReady.listen(container)
}
